export const CHECK_DIPLOMAS = "CHECK_DIPLOMAS";
export const CHECK_DIPLOMAS_SENDING = "CHECK_DIPLOMAS_SENDING";
export const CHECK_DIPLOMAS_LOADED = "CHECK_DIPLOMAS_LOADED";
